
import React from 'react';
import { AspectRatio } from '@/components/ui/aspect-ratio';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';

interface ResponsiveImageProps {
  src: string;
  alt: string;
  width: number;
  height: number;
  mobileWidth?: number;
  className?: string;
  priority?: boolean;
  aspectRatio?: number;
  sizes?: string;
  loading?: "lazy" | "eager";
  webpSrc?: string;
}

export const ResponsiveImage = ({
  src,
  alt,
  width,
  height,
  mobileWidth,
  className,
  priority = false,
  aspectRatio,
  sizes = "(max-width: 768px) 100vw, 50vw",
  loading,
  webpSrc,
}: ResponsiveImageProps) => {
  const isMobile = useIsMobile();
  const ratio = aspectRatio || (height / width);
  const imgWidth = isMobile && mobileWidth ? mobileWidth : width;
  const imgHeight = isMobile && mobileWidth ? Math.round(mobileWidth * ratio) : height;
  
  const loadingAttr = loading || (priority ? "eager" : "lazy");
  
  return (
    <div className={cn("overflow-hidden", className)}>
      {aspectRatio ? (
        <AspectRatio ratio={aspectRatio}>
          {webpSrc ? (
            <picture>
              <source srcSet={webpSrc} type="image/webp" />
              <img 
                src={src} 
                alt={alt} 
                width={imgWidth} 
                height={imgHeight}
                loading={loadingAttr}
                sizes={sizes}
                className="object-cover w-full h-full"
              />
            </picture>
          ) : (
            <img 
              src={src} 
              alt={alt} 
              width={imgWidth} 
              height={imgHeight}
              loading={loadingAttr}
              sizes={sizes}
              className="object-cover w-full h-full"
            />
          )}
        </AspectRatio>
      ) : (
        webpSrc ? (
          <picture>
            <source srcSet={webpSrc} type="image/webp" />
            <img 
              src={src} 
              alt={alt} 
              width={imgWidth} 
              height={imgHeight}
              loading={loadingAttr}
              sizes={sizes}
              className={cn("object-cover", className)}
            />
          </picture>
        ) : (
          <img 
            src={src} 
            alt={alt} 
            width={imgWidth} 
            height={imgHeight}
            loading={loadingAttr}
            sizes={sizes}
            className={cn("object-cover", className)}
          />
        )
      )}
    </div>
  );
};
